import { Card, Progress, Steps, Tag, Tooltip, Typography, message } from "antd"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CaretLeftOutlined, CaretRightOutlined, CreditCardOutlined, CrownFilled, DeleteOutlined, KeyOutlined, PushpinOutlined, RedoOutlined, RocketFilled, RocketOutlined, SearchOutlined, SettingOutlined, ShopOutlined, StarFilled, TrophyOutlined } from "@ant-design/icons";
import moment from "moment";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { useFetch } from "../../../../../hooks/useFetch/useFetch";
import { authRequest } from "../../../../../common/request/authRequest";
import { authFetch } from "../../../../../common/request/authFetch";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import TableLZM from "../../../../components/design/table/TableLZM";
import { NewBenchmark } from "./drawers/NewBenchmark";
import { BenchmarkModal } from "./drawers/BenchmarkModal";
import { EmptyStateBox } from "../../../../components/design/EmptyStateBox/EmptyStateBox";
import { AddCompetitorsDrawer } from "../../pageLocations/Drawer/AddCompetitorsDrawer";
import { ColorStar } from "../../../../../common/utils/ColorStar";

const { Paragraph } = Typography;

export const Benchmark = (props: {selectedType: any}) => {
	
	const [openDrawer, setOpenDrawer] = useState<any>(null);    
	const [newBenchmarkModal, setNewBenchmarkModal] = useState<any>(false);
	const [benchmarks, setBenchmarks] = useState<any>(null);    
	const [updateData, setUpdateData] = useState(false);	
	const [currentBenchmarkIdx, setCurrentBenchmarkIdx] = useState<number>(0);
	const [currentBenchmark, setCurrentBenchmark] = useState<any>(null);
	const [benchmarkId, setBenchmarkId] = useState<any>('');    
	const [benchmarkMap, setBenchmarkMap] = useState<any>(null);
	const { projectGroup } = useAuth();
    const { t } = useTranslation();
	
	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark/historic?periodOpt=${props.selectedType}`,
		{},
		[updateData],
		(data) => {
			setBenchmarks(data);      
			setCurrentBenchmarkIdx(data.length - 1);  	
			setBenchmarkId('');
		}
	);

	useEffect(() => {
        
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark/current?periodOpt=${props.selectedType}${benchmarkId}`,
            { method: 'GET' }
            )
            .then((data) => {                
                setCurrentBenchmark(data);                                                                
            })            
    }, [benchmarkId, projectGroup]); 

	const refreshCompetitors = async (id: string): Promise<void> => {
				
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark/${id}`, { method: 'PUT'})
			.then((res) => {
				if (res) {
					message.success('Lista de competidores actualizada', 3);
					setUpdateData(!updateData);                 
				} else {
				  message.error('Problema al actualizar la lista de competidores', 3);
				}
		})
	}    

	const deleteBenchmark = async (id: string): Promise<void> => {
				
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark/${id}`, { method: 'DELETE'})
			.then((res) => {
				if (res) {
					message.success('Benchmark eliminado', 3);
					setUpdateData(!updateData);                 
				} else {
				  message.error('Problema al eliminar el benchmark', 3);
				}
		})
	}    	

	const STATS_COLUMNS: any = [		
		{
			title: 'Negocio',
			key: 'bizz',						
			render: (text: string, record: any) => (				
				<>
				{record.ranking < 4 && <CrownFilled style={{fontSize:22, color: record.ranking == 1 ? 'darkorange' : 'slategrey', marginRight: '10px'}}/>}
				
				{record.myBusiness ?
					<Tag style={{color:'white', borderRadius:'20px'}} color="dodgerblue"><b style={{color:'white'}}>#{record.ranking}</b> {record.name}</Tag> 
					:
					<Tag style={{color:'slategrey', borderRadius:'20px', border:'1px solid slategrey'}} color="white"><b style={{color:'black'}}>#{record.ranking}</b> {record.name}</Tag>
				}
				<div style={{color: 'silver'}}>{record.numberOfImpressions} locales top20 en {record.numberOfInCity} ciudades</div>
				</>
			)			
		},
		{
			title: 'Presencia',
			key: 'view',			
			align:'center',			
			render: (text: string, record: any) => (				
				<>
					<div><Progress width={50} trailColor="lavender" type="dashboard" percent={Math.round(100 * record.numberOfInCity / record.numberOfCities) } /></div>
					<small style={{color: 'slategrey'}}>Top20 en {record.numberOfInCity} ciudades</small>						
				</>
			)			
		},
		{
			title: 'Reputación',
			key: 'score',						
			align:'center',
			render: (text: string, record: any) => (				
				<div>								
					{record.numberOfInCity > 0 && 
						record.avgReviews > 0 ?
						<div style={{alignItems:'center', justifyContent:'center'}}>
							<div><ColorStar style={{ fontSize: '18px' }} value={Math.round(10 * record.avgRate) / 10}/></div>						
							<small style={{color: 'slategrey', marginLeft:'10px'}}>{Math.round(record.avgReviews)} reseñas</small>						
						</div>					
						:
						<small style={{color: 'silver'}}>No se muestra</small>							
					}			
				</div>
			)			
		},		
		{
			title: 'Google Maps',
			key: 'position',						
			align:'center',
			render: (text: string, record: any) => (										
				<>
					{record.numberOfInCity > 0 && <div style={{ display: 'flex',  flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
						<div style={{ height: '34px', width: '34px', borderRadius: '50%', border:`solid 1px ${DOT_COLOR_AVG[Math.round(record.avgPosition)]}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{Math.round(record.avgPosition)}</div>					
						<small style={{color: 'slategrey'}}>Posición Media</small>						
					</div>}
				</>
			)			
		},		
		{
			title: 'Google Ads',
			key: 'ads',						
			align:'center',
			render: (text: string, record: any) => (										
				<div>
					{record.numberOfSponsored == 0 ?
					<small style={{color: 'silver'}}>Sin Anuncios</small>
					:
					<div><div><CreditCardOutlined style={{fontSize:22, color: 'dodgerblue'}}/></div> {Math.round(100 * record.numberOfSponsored / record.numberOfImpressions)}% Anuncios</div>
					}
				</div>	
			)			
		},
		{
			title: 'Link',
			key: 'map',						
			render: (text: string, record: any) => (										
				<div>					
					<a onClick={() => { setBenchmarkMap({benchmarkId: currentBenchmark.id, competitor: record.name, keyword: currentBenchmark.keyword, numberOfCities: currentBenchmark.numberOfCities, allCompetitors: currentBenchmark.competitors }) }}>Ver mapa</a>	
				</div>	
			)			
		}		
	]

    return (
		<>  			
			<div style={{display:'flex', color:'slategray', justifyContent:'space-between', alignItems:'top', marginRight:'20px'}}>	
			{ 
                benchmarks && currentBenchmarkIdx >= 0 &&
                    <div style={{overflowX: 'scroll'}}>
                        <Steps current={currentBenchmarkIdx} status="process" progressDot style={{marginTop:'20px'}} >
                            {benchmarks.slice(-10).toReversed().map((benchmark: any, index: any)=>(
                                <Steps.Step 
                                    key={index}                                                                                                 
                                    title={
                                        <Tooltip 
                                            title = {<>
                                                        <div><b>{moment.utc(benchmark.created).local().fromNow()}</b></div> 
                                                    </>}>											
                                            <a onClick={() => {setBenchmarkId('&benchmarkId=' + benchmark.id); setCurrentBenchmarkIdx(index)}}>
                                                {index === currentBenchmarkIdx ? 
                                                    <b style={{color:'teal'}}><small> {moment.utc(benchmark.created).local().format('ll')}</small></b> 
                                                    :
                                                    <small>{moment.utc(benchmark.created).local().format('ll')}</small>
                                                }
                                            </a> 
											
											<Tag style={{background:index === currentBenchmarkIdx ? 'teal' :'white', color: index === currentBenchmarkIdx ? 'white' : 'silver', border:'0px solid teal'}}><small><b>{benchmark.keyword} x{benchmark.numberOfCities}</b></small></Tag>
											
                                        </Tooltip>
                                    }/>
                                ))
                            }                            
                        </Steps>         
                    </div>                
                }				
				<div>	                  				            					
					<ButtonLZ size='small' type='ghost' onClick={() => { setOpenDrawer(projectGroup.project) }} >
						<div><SettingOutlined /> Mis Competidores</div>
					</ButtonLZ>         
					<ButtonLZ size='small' onClick={() => {setNewBenchmarkModal(true)}} style={{marginLeft:'10px'}}>
						<RocketOutlined/> Nuevo benchmark
					</ButtonLZ>  
				</div>						
			</div>		
			{benchmarks && !benchmarks.length ? (
				<div style={{ margin: '20px 0' }}>
					<EmptyStateBox
						icon={<RocketOutlined />}
						title="No hay benchmarks"
						description="Crea un nuevo benchmark para analizar competidores por ciudades."
					/>
				</div>
			) : currentBenchmark ? (
				<TableLZM					
				rowKey='locationName'
				pagination={{ defaultPageSize: 20 }}
				//scroll={{ x: true }}
				columns={STATS_COLUMNS}				
				dataSource={currentBenchmark.competitorStats}
				/>
			) : null}											
			<br/><br/>
			{currentBenchmark && (
			<div style={{display:'flex', justifyContent: 'flex-end'}}>					
					<div>
						<ButtonLZ size='small' type='link' onClick={() => {deleteBenchmark(currentBenchmark.id)}}><DeleteOutlined/> Borrar benchmark</ButtonLZ>
						<ButtonLZ size='small' type='link' onClick={() => {refreshCompetitors(currentBenchmark.id)}}><RedoOutlined/>Refrescar competidores</ButtonLZ>
					</div>								
				</div>
			)}
							
			{ newBenchmarkModal && <NewBenchmark onClose={() => setNewBenchmarkModal(false)} onFinish={() => {setNewBenchmarkModal(false); setUpdateData(!updateData)}}/> }
			{ benchmarkMap && <BenchmarkModal benchmarkMap={benchmarkMap} onFinish={() => setBenchmarkMap(null)}/> }
			{ openDrawer && <AddCompetitorsDrawer benchmarckId={openDrawer} onClose={() => setOpenDrawer(false)}/> }	
		</>
    )
}

export const DOT_COLOR_AVG: any = {
    "1": "green",  
    "2": "green",  
    "3": "green",  
    "4": "LimeGreen", 
    "5": "LimeGreen", 
    "6": "LimeGreen", 
    "7": "LimeGreen", 
    "8": "LimeGreen", 
    "9": "LimeGreen", 
    "10": "LimeGreen",
    "11": "darkorange", 
    "12": "darkorange", 
    "13": "darkorange", 
    "14": "darkorange", 
    "15": "darkorange", 
    "16": "crimson", 
    "17": "crimson", 
    "18": "crimson", 
    "19": "crimson", 
    "20": "crimson", 
    "21": "black"    
}